export function qurl(field, value) {
  if (value) return `/?q=${field}: ${value}`;
  return `/?q=${field}`;
}
